// статусы заявки
const statementCreateByLaboratory = 1 // Создано испытательной лабораторией
const statementWaitForClientSignature = 2 // Заявка очікує підписання клієнтом
const statementWaitForCategoryChoices = 3 // Очікує вибору категорії КТЗ
const statementWaitForDecision = 4 // Очікує рішення за заявкою
const statementReject = 5 // Відхилено
const statementAllowedForInspection = 6 // Допущено до огляду
const statementDecisionWaitSignature = 7 // Очікує підписання рішення аудитором ОС
const statementInProgressInspection = 8 // Проводиться перевірка відповідності
const statementWaitSignatureAuditor = 9 // Очікує підписання аудитора ОС
const statementCertificateInProgress = 10 // Выдача сертифіката
const statementCertificateIssued = 11 // Сертифікат видано
const statementCertificateNotIssued = 12 // Сертифікат не видано
const statementWaitForLaboratory = 13 // Очікує вибору філії лабораторії
const statementWaitForCertificationAgency = 25 // Очікує вибору органу сертифікації
const statementWaitSignatureManager = 14 // Очікує підписання менеджера ВЛ
const statementDecisionWaitForDirectorSignature = 15 // Очікує підписання рішення директором ОС
const statementDecisionWaitForSignatureExpert = 16 // Очікує підписання протоколу експертом
const statementDecisionWaitForSignatureChief = 17 // Очікує підписання протоколу керівником дільниці ВЛ
const statementDecisionWaitForSignatureCertAuditor = 18 // Очікує підписання рішення о видачі сертіфіката аудитором ОС
const statementDecisionWaitForSignatureCertDirector = 19
const statementWaitReprocessing = 26 // Очікує переробки
const statementWaitingAddInspectionProtocolNumber = 27 // Очікує додавання номеру протоколу огляду КТЗ


// Статуси заявок клієнта отк/сертифікації
const statusWaitReview = 1  // Заява клієнта очікує перегляду
const statusClientCanceled = 2 // Заява клієнта відхилена
const statusClientSetDateKtz = 3 // Призначена дата для огляду ТЗ
const statusClientInWork = 4 // Заява клієнта в роботі
const statusClientCompleted = 5 // Роботи по заяві клієнта завершені

// Очікує підписання рішення о видачі сертіфіката директором ОС
const statementWaitSignatureCertDirector = 20 // Очікує підписання сертіфіката директором ОС

// статуси ручної заявки - manual statement
const statementManualWaitForClientSignature = 1 // Заявка очікує підписання клієнтом
const statementManualWaitSignatureAuditor = 2 // Очікує підписання аудитора ОС
const statementManualWaitSignatureManager = 3 // Очікує підписання менеджера ВЛ
const statementManualWaitActIdentificationDecision = 4 // Очікує рішення по акту ідентифікації
const statementManualActIdentificationWaitSignatureAuditor = 5 // Акт очікує підпису аудитора ОС
const statementManualActIdentificationWaitSignatureManager = 6 // Очікує підписання менеджера ВЛ
const statementManualWaitForCertificationAgencyChoices = 25 // Очікує вибору ОС
const statementManualWaitChoiceLegalActs = 7 // Очікує вибору нормативної бази
const statementManualRejected = 26 // Відхилено
const statementManualCharacterizationVehicle = 11 // Заповнення хараектеристик КТЗ
const statementManualWaitSignatureCertAuditor = 12 // Очікує підписання сертифіката аудитором ОС
const statementManualWaitSignatureCertDirector = 13 // Очікує підписання сертіфіката аудитором керівником ОС
const statementManualCertificateIssued = 14 // Сертифікат видано

// статуси акту ідентифікації
const identificationActWaitDecisionAuditor = 21 // Ідентифікація КТЗ на відповідність документам
const identificationActWaitSignatureForAuditor = 23 // Акт очікує підпису аудитора ОС
const identificationActWaitSignatureForManager = 24 // Очікує підписання менеджера ВЛ

// статусы решения по заявке
const statementDecisionWaitForSignatureAuditor = 3 // Очікує підписання Аудитора ОС
const statementDecisionWaitForSignatureDirector = 4 // Очікує підписання Директора ОС
const statementDecisionWaitForDecision = 2 // Очікує рішення
const statementDecisionValid = 1 // Дійсний

// статусы протокола осмотра
const inspectionWaitComplianceCompleted = 1 // Ожидает заполнение соответствия ТС правовым актам
const inspectionUploadProofs = 2 // Завантаження доказової бази
const inspectionWaitForDecision = 3 // Очікує рішення щодо можливості видачі сертифіката
const inspectionWaitStand = 5 // Очікує проведення випробування на стенді
const inspectionRejected = 6 // Відхилено
const inspectionIssueCertificate = 7 // Видача сертифіката відповідності
const inspectionWitSignatureLabExpert = 8 // Очікує підписання лаборанта ВЛ
const inspectionWitSignatureLabChief = 9 // Очікує підписання керівника дільниці ВЛ
const inspectionWaitReprocessing = 10 // Очікує переробки
const waitingAddInspectionProtocolNumber = 11 // Очікує додавання номеру протоколу огляду КТЗ

// статусы решения для решения о выдачи сертификата
const decisionIssueCertificateWaitDecision = 1 // Очікує вибору
const decisionIssueCertificateValid = 2 // Дійсний
const decisionIssueCertificateWaitSignatureAuditor = 3 // Очікує підписання Аудитора ОС
const decisionIssueCertificateWaitSignatureDirector = 4 // Очікує підписання Директора ОС
const decisionIssueCertificateWaitReprocessing = 5 // Переоформлення

// статусы сертификата
const certificateWaitSignatureDirector = 2 // Очікує підписання директора ОС
const certificateWaitSignatureAuditor = 4 // Очікує підписання аудитора ОС
const certificateValid = 1 // Дійсний

// decision для любых доков о решении
const decisionDecisionApproved = 1 // Схвалено
const decisionDecisionReject = 2 // Відхилено
const decisionDecisionWaitChoice = 3 // Очікує вибору

// статусы заявки на ОТК
const statementMTIWaitClientSign = 1 // Заявка очікує підписання клієнтом
const statementMTIWaitPayment = 2 // Очікує оплати
const statementMTIWaitInspection = 3 // Очікує проходження ОТК
const statementMTIInProgressInspection = 4 // Проходження ОТК
const statementMTIWaitExpertSignature = 5 // Протокол очікує підпису лаборанта
const statementMTIWaitSecondExpertSignature = 6 // Протокол очікує підпису другого лаборанту
const statementMTIWaitChiefSignature = 7 // Очікує підписання керівника дільниці ВЛ
const statementProcessMTIFinished = 8 // Процедуру ОТК завершено
const statementMTIWaitDecision = 9 // Очікує схвалення
const statementMTIReject = 10 // Відхилено
const statementMTIWaitChiefSignatureAct = 11 // Акт невідповідності очікує підпісу керівника дільниці ВЛ
const statementMTIWaitChiefSignatureProtocol = 12 // Протокол технічного огляду очікує підпису керівника дільниці ВЛ

// статусы огляду на ОТК
const inspectionMTIWaitComplianceCompleted = 1 // Очікує заповнення відподностей ТС
const inspectionMTIWaitStandInspection = 2 //і Очікує іспити на стендах
const inspectionMTIWaitSignatureExpert = 3 // Очікує підпису лаборанта
const inspectionMTIWaitSignatureSecondExpert = 4 // Очікує підпису другого лаборанта
const inspectionMTIWaitSignatureLabChief = 5 // Очікує підписання керівника дільниці ВЛ
const inspectionProcessMTIFinished = 6 // Процедуру ОТК завершено
const inspectionMTIWaitSignatureLabChiefAct = 7 // Акт невідповідності очікує підпісу керівника дільниці ВЛ
const inspectionMTIWaitSignatureLabChiefProtocol = 8 // Протокол технічного огляду очікує підпису керівника дільниці ВЛ

// рішення за результатами проходження ОТК
const inspectionMTIDecisionValid = 1 // Відповідає
const inspectionMTIDecisionTinyDiscrepancy = 2 // Незначна невідповідність
const inspectionMTIDecisionSignificantDiscrepancy = 3 // Істотна невідповідність
const inspectionMTIDecisionDangerousDiscrepancy = 4 // Небезпечна невідповідність
const inspectionMTIDecisionWaitAnswer = 5 // Очікує вибору

// decision для заявки на заключение договора о сотрудничестве вл/ос
const contractAwaitingDecision = 1 // Очікує рішення
const contractValid = 2 // Дійсний
const contractInvalid = 3 // Недійсний
const contractNeedsExtension = 4 // Потребує пролонгації

// Статуси угод про співпрацю вл/ос
const activeCooperationAgreement = 1 // Дійсний
const expiredCooperationAgreement = 2 // Недійсний

// Статуси акту ідентифікації
const identificationActWaitDecision = 1 // Очікує рішення
const identificationActWaitClientSignature = 2 // Акт очікує підпису клієнта
const identificationActWaitSignatureAuditor = 3 // Очікує підписання аудитором ОС
const identificationActWaitSignatureManager = 4 // Очікує підписання менеджером ВЛ
const identificationActValid = 5 // Дійсний
const identificationActRejected = 6 // Відхилено

// Статуси співробітників
const employeeActive = 1 // Активний
const employeeDeactivated = 2 // Деактивований
const employeeSuspended = 3 // Призупинено, в результаті перевірки зовнішніх органів

// Статуси не системних співробітників Органу сертифікації
const employeeNotActivated = 1 // Не активований, потрібен в системі
const employeeOutOfSystem = 2 //Не системний
const employeeOutOfSystemDeactivated = 4 // Деактивований

// Статуси робочих ліній у філіях ВЛ
const workLineApproved = 1 // Схвалено
const workLineWaitRefinement = 5 // Очікує доопрацювання
const workLineWaitFilling = 3 // Очікує заповнення
const workLineModeration = 4 // Відправлена на модерацію

// Статуси модерації філій вимірювальних лабораторій
const laboratoryBranchWaitForModeration = 1 // Очікує модерації
const laboratoryBranchReprocessing = 2 // На доопрацюванні
const laboratoryBranchApproved = 3 // Прийнято в роботу
const laboratoryBranchWaitAddMtz = 4 // Очікує заповнення МТЗ


// Статуси зверннення в Технічну підтримку
const inquiryNew = 1 // Нове звернення
const inquiryReviewed = 2 // Переглянуто
const inquiryInProgress = 3 // Взято на розгляд
const inquiryProcessed = 4 // В роботі
const inquiryDone = 5 // Вирішено
const inquiryClosed = 6 // Закрито

// Статуси додавання нових філій для ВЛ
const statementBranchWaitTechSupportReview = 1 // Очікує перевірки технічної підримки
const statementBranchWaitNaauReview = 2 // Очікує перевірки НААУ
const statementBranchApproved = 3 // Філія по заяві створена
const statementBranchRejected = 4 // Заява на створення філії відхилена
const statementBranchTechSentForReprocessing = 10 // Заява відправлена на переробку, тех підримки
const statementBranchSentForReprocessing = 11 // Заява відправлена на переробку

// заповнення характеристик КТЗ
const manualInspectionWaitFilling = 1 // Очікує заповнення
const manualInspectionReady = 2 // Готовий

const statement = id => {
  switch (id) {
    case statementCreateByLaboratory:
      return { color: 'info', textColor: 'white--text', text: 'statuses.createByLaboratory' }
    case statementWaitForClientSignature:
      return { color: 'info', textColor: 'white--text', text: 'statuses.waitForClientSignature' }
    case statementWaitForCategoryChoices:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'statuses.statementWaitForCategoryChoices'
      }
    case statementWaitForDecision:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.statementWaitForDecision' }
    case statementReject:
      return { color: 'dangerDark', textColor: 'white--text', text: 'statuses.statementReject' }
    case statementDecisionWaitSignature:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.statementWaitSignatureAuditor' }
    case statementAllowedForInspection:
      return { color: 'greenDark', textColor: 'white--text', text: 'statuses.statementAllowedForInspection' }
    case statementWaitSignatureAuditor:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.statementWaitSignatureAuditor' }
    case statementInProgressInspection:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'statuses.statementInProgressInspection'
      }
    case statementCertificateInProgress:
      return { color: 'info', textColor: 'white--text', text: 'statuses.statementCertificateInProgress' }
    case statementCertificateIssued:
      return { color: 'successDark', textColor: 'white--text', text: 'statuses.statementCertificateIssued' }
    case statementCertificateNotIssued:
      return { color: 'dangerDark', textColor: 'white--text', text: 'statuses.statementCertificateNotIssued' }
    case statementWaitForLaboratory:
      return { color: 'info', textColor: 'white--text', text: 'statuses.statementWaitForLaboratory' }
    case statementWaitForCertificationAgency:
      return {
        color: 'info',
        textColor: 'white--text',
        text: 'statuses.statementWaitForCertificationAgency'
      }
    case statementWaitSignatureManager:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.statementWaitSignatureManager' }
    case statementDecisionWaitForDirectorSignature:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.certificateWaitSignatureDirector' }
    case statementDecisionWaitForSignatureExpert:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.inspectionWitSignatureLabExpert' }
    case statementDecisionWaitForSignatureChief:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.inspectionWitSignatureLabChief' }
    case statementDecisionWaitForSignatureCertAuditor:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.statementWaitSignatureAuditor' }
    case statementDecisionWaitForSignatureCertDirector:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'statuses.certificateWaitSignatureDirector'
      }
    case statementWaitSignatureCertDirector:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.certificateWaitSignatureDirector' }
    case identificationActWaitDecisionAuditor:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'statuses.identificationActWaitDecisionAuditor'
      }
    case identificationActWaitSignatureForAuditor:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'statuses.identificationActWaitSignatureForAuditor'
      }
    case identificationActWaitSignatureForManager:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'statuses.identificationActWaitSignatureForManager'
      }
    // треба ці статуси для нових КТЗ виносити в окремий об'єкт - бо є id статусів які співпадають і несуть різне значення
    // case statementManualRejected:
    //   return { color: 'dangerDark', textColor: 'white--text', text: 'statuses.rejected' }
    case statementWaitReprocessing:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.statementWaitReprocessing' }
    case statementWaitingAddInspectionProtocolNumber:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.waitingAddInspectionProtocolNumber' }
    default:
      return { color: 'successDark', textColor: 'white--text', text: 'statuses.default' }
  }
}

const statementClient = id => {
  switch (id) {
    case statusWaitReview:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.clientWaitReview' }
    case statusClientCanceled:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.statementReject' }
    case statusClientSetDateKtz:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.clientWaitReviewTransport' }
    case statusClientInWork:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inquiryProcessed' }
    case statusClientCompleted:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.completed' }
  }
}

const statementManual = id => {
  switch (id) {
    case statementManualWaitForClientSignature:
      return {color: 'info lighten-1', textColor: 'white--text', text: 'statuses.statementManualWaitForClientSignature'}

    case statementManualWaitSignatureAuditor:
      return {color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.statementManualWaitSignatureAuditor'}

    case statementManualWaitSignatureManager:
      return {color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.statementManualWaitSignatureManager'}

    case statementManualWaitActIdentificationDecision:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementManualWaitActIdentificationDecision'
      }

    case statementManualActIdentificationWaitSignatureAuditor:
      return {
        color: 'warning lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementManualActIdentificationWaitSignatureAuditor'
      }

    case statementManualActIdentificationWaitSignatureManager:
      return {
        color: 'warning lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementManualActIdentificationWaitSignatureManager'
      }

    case statementManualWaitForCertificationAgencyChoices:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementManualWaitForCertificationAgencyChoices'
      }

    case statementManualWaitChoiceLegalActs:
      return {color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.statementManualWaitChoiceLegalActs'}

    case statementManualRejected:
      return {color: 'error lighten-1', textColor: 'white--text', text: 'statuses.statementManualRejected'}

    case statementManualCharacterizationVehicle:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementManualCharacterizationVehicle'
      }
    case statementManualWaitSignatureCertAuditor:
      return {
        color: 'warning lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementManualWaitSignatureCertAuditor'
      }
    case statementManualWaitSignatureCertDirector:
      return {
        color: 'warning lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementManualWaitSignatureCertDirector'
      }
    case statementManualCertificateIssued:
      return {
        color: 'success lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementManualCertificateIssued'
      }
    default:
      return {color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default'}
  }
}

const manualInspection = id => {
  switch (id) {
    case manualInspectionWaitFilling:
      return {color: 'info lighten-1', textColor: 'white--text', text: 'statuses.manualInspectionWaitFilling'}

    case manualInspectionReady:
      return {color: 'info lighten-1', textColor: 'white--text', text: 'statuses.manualInspectionReady'}

    default:
      return {color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default'}
  }
}

const statementDecision = id => {
  switch (id) {
    case statementDecisionWaitForSignatureAuditor:
      return {
        color: 'warning lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementDecisionWaitForSignatureAuditor'
      }
    case statementDecisionWaitForSignatureDirector:
      return {
        color: 'warning lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementDecisionWaitForSignatureDirector'
      }
    case statementDecisionWaitForDecision:
      return {
        color: 'warning lighten-1',
        textColor: 'white--text',
        text: 'statuses.statementDecisionWaitForDecision'
      }
    case statementDecisionValid:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.statementDecisionValid' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const inspection = id => {
  switch (id) {
    case inspectionWaitComplianceCompleted:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inspectionWaitComplianceCompleted' }
    case inspectionUploadProofs:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inspectionUploadProofs' }
    case inspectionWaitForDecision:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inspectionWaitForDecision' }
    case inspectionWaitStand:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inspectionWaitStand' }
    case inspectionRejected:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.inspectionRejected' }
    case inspectionIssueCertificate:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inspectionIssueCertificate' }
    case inspectionWitSignatureLabExpert:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inspectionWitSignatureLabExpert' }
    case inspectionWitSignatureLabChief:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inspectionWitSignatureLabChief' }
    case inspectionWaitReprocessing:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inspectionWaitReprocessing' }
    case waitingAddInspectionProtocolNumber:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.waitingAddInspectionProtocolNumber' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const decisionIssueCertificate = id => {
  switch (id) {
    case decisionIssueCertificateWaitDecision:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.decisionIssueCertificateWaitDecision' }
    case decisionIssueCertificateValid:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.decisionIssueCertificateValid' }
    case decisionIssueCertificateWaitSignatureAuditor:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'statuses.decisionIssueCertificateWaitSignatureAuditor'
      }
    case decisionIssueCertificateWaitSignatureDirector:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'statuses.decisionIssueCertificateWaitSignatureDirector'
      }
    case decisionIssueCertificateWaitReprocessing:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.decisionIssueCertificateWaitReprocessing' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const certificate = id => {
  switch (id) {
    case certificateWaitSignatureDirector:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.certificateWaitSignatureDirector' }
    case certificateWaitSignatureAuditor:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.certificateWaitSignatureAuditor' }
    case certificateValid:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.certificateValid' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const anyDecision = id => {
  switch (id) {
    case decisionDecisionApproved:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.decisionDecisionApproved' }
    case decisionDecisionReject:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.decisionDecisionReject' }
    case decisionDecisionWaitChoice:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.decisionDecisionWaitChoice' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const statementMTI = id => {
  switch (id) {
    case statementMTIWaitClientSign:
      return {
        color: 'info',
        textColor: 'white--text',
        text: 'technicalControlStatuses.statementMTIWaitClientSign'
      }
    case statementMTIWaitPayment:
      return {
        color: 'info',
        textColor: 'white--text',
        text: 'technicalControlStatuses.statementMTIWaitPayment'
      }
    case statementMTIWaitDecision:
      return {
        color: 'info',
        textColor: 'white--text',
        text: 'technicalControlStatuses.statementMTIWaitDecision'
      }
    case statementMTIReject:
      return {
        color: 'error lighten-4',
        textColor: 'white--text',
        text: 'technicalControlStatuses.statementReject'
      }
    case statementMTIWaitInspection:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'technicalControlStatuses.statementMTIWaitInspection'
      }
    case statementMTIInProgressInspection:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'technicalControlStatuses.statementMTIInProgressInspection'
      }
    case statementMTIWaitExpertSignature:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionWitSignatureLabExpert'
      }
    case statementMTIWaitSecondExpertSignature:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'technicalControlStatuses.statementMTIWaitSecondExpertSignature'
      }
    case statementMTIWaitChiefSignature:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionWitSignatureLabChief'
      }
    case statementMTIWaitChiefSignatureAct:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionMTIWaitChiefSignatureAct'
      }
    case statementMTIWaitChiefSignatureProtocol:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionMTIWaitChiefSignatureProtocol'
      }
    case statementProcessMTIFinished:
      return {
        color: 'warningDark',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionProcessMTIFinished'
      }
    default:
      return {
        color: 'primary lighten-4',
        textColor: 'white--text',
        text: 'statuses.default'
      }
  }
}

const inspectionMTI = id => {
  switch (id) {
    case inspectionMTIWaitComplianceCompleted:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionWaitComplianceCompleted'
      }
    case inspectionMTIWaitStandInspection:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionWaitStand'
      }
    case inspectionMTIWaitSignatureExpert:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionWitSignatureLabExpert'
      }
    case inspectionMTIWaitSignatureSecondExpert:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionMTIWaitSignatureSecondExpert'
      }
    case inspectionMTIWaitSignatureLabChief:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionWitSignatureLabChief'
      }
    case inspectionMTIWaitSignatureLabChiefAct:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionMTIWaitChiefSignatureAct'
      }
    case inspectionMTIWaitSignatureLabChiefProtocol:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionMTIWaitChiefSignatureProtocol'
      }
    case inspectionProcessMTIFinished:
      return {
        color: 'info lighten-1',
        textColor: 'white--text',
        text: 'technicalControlStatuses.inspectionProcessMTIFinished'
      }
    default:
      return {
        color: 'primary lighten-1',
        textColor: 'white--text',
        text: 'statuses.default'
      }
  }
}

const inspectionMTIDecision = id => {
  switch (id) {
    case inspectionMTIDecisionValid:
      return {
        color: 'success lighten-1',
        textColor: 'white--text',
        text: 'statuses.inspectionMTIDecision.inspectionDecisionValid'
      }
    case inspectionMTIDecisionTinyDiscrepancy:
      return {
        color: 'error lighten-1',
        textColor: 'white--text',
        text: 'statuses.inspectionMTIDecision.inspectionDecisionTinyDiscrepancy'
      }
    case inspectionMTIDecisionSignificantDiscrepancy:
      return {
        color: 'error lighten-1',
        textColor: 'white--text',
        text: 'statuses.inspectionMTIDecision.inspectionDecisionSignificantDiscrepancy'
      }
    case inspectionMTIDecisionDangerousDiscrepancy:
      return {
        color: 'error lighten-1',
        textColor: 'white--text',
        text: 'statuses.inspectionMTIDecision.inspectionDecisionDangerousDiscrepancy'
      }
    case inspectionMTIDecisionWaitAnswer:
      return {
        color: 'warning lighten-1',
        textColor: 'white--text',
        text: 'statuses.inspectionMTIDecision.inspectionDecisionWaitAnswer'
      }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const contractDecision = id => {
  switch (id) {
    case contractAwaitingDecision:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.contractAwaitingDecision' }
    case contractValid:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.decisionDecisionApproved' }
    case contractInvalid:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.decisionDecisionReject' }
    case contractNeedsExtension:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.contractNeedsExtension' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const cooperationAgreement = id => {
  switch (id) {
    case activeCooperationAgreement:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.contractValid' }
    case expiredCooperationAgreement:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.contractInvalid' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const identificationAct = id => {
  switch (id) {
    case identificationActWaitDecision:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.identificationActWaitDecision' }
    case identificationActWaitClientSignature:
      return {
        color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.identificationActWaitClientSignature'
      }
    case identificationActWaitSignatureAuditor:
      return {
        color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.identificationActWaitSignatureAuditor'
      }
    case identificationActWaitSignatureManager:
      return {
        color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.identificationActWaitSignatureManager'
      }
    case identificationActValid:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.identificationActValid' }
    case identificationActRejected:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.identificationActRejected' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const employeeStatus = id => {
  switch (id) {
    case employeeActive:
      return { color: 'info', textColor: 'white--text', text: 'statuses.employeeActive' }
    case employeeDeactivated:
      return { color: 'error lighten-4', textColor: 'white--text', text: 'statuses.employeeDeactivated' }
    case employeeSuspended:
      return { color: 'warningDark', textColor: 'white--text', text: 'statuses.employeeSuspended' }
    default:
      return { color: 'primary lighten-4', textColor: 'white--text', text: 'statuses.default' }
  }
}

const employeeOutOfSystemStatus = id => {
  switch (id) {
    case employeeNotActivated:
      return { color: 'info', textColor: 'white--text', text: 'statuses.employeeNotActivated' }
    case employeeOutOfSystem:
      return { color: 'error lighten-4', textColor: 'white--text', text: 'statuses.employeeOutOfSystem' }
    case employeeOutOfSystemDeactivated:
      return { color: 'error lighten-4', textColor: 'white--text', text: 'statuses.employeeDeactivated' }
    default:
      return { color: 'primary lighten-4', textColor: 'white--text', text: 'statuses.default' }
  }
}

const workLineStatus = id => {
  switch (id) {
    case workLineApproved:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.workLineApproved' }
    case workLineWaitRefinement:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.workLineWaitRefinement' }
    case workLineWaitFilling:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.workLineWaitFilling' }
    case workLineModeration:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.workLineModeration' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const moderationMTZStatus = id => {
  switch (id) {
    case laboratoryBranchReprocessing:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.laboratoryBranchReprocessing' }
    case laboratoryBranchWaitForModeration:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.laboratoryBranchWaitForModeration' }
    case laboratoryBranchApproved:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.laboratoryBranchApproved' }
    case laboratoryBranchWaitAddMtz:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.laboratoryBranchWaitAddMtz' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const inquiry = id => {
  switch (id) {
    case inquiryNew:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inquiryNew' }
    case inquiryReviewed:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.inquiryReviewed' }
    case inquiryInProgress:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.inquiryInProgress' }
    case inquiryProcessed:
      return { color: 'info lighten-1', textColor: 'white--text', text: 'statuses.inquiryProcessed' }
    case inquiryDone:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.inquiryDone' }
    case inquiryClosed:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.inquiryClosed' }
    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

const statementBranch = id => {
  switch (id) {
    case statementBranchWaitTechSupportReview:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.statementBranchWaitTechSupportReview' }
    case statementBranchWaitNaauReview:
      return { color: 'warning lighten-1', textColor: 'white--text', text: 'statuses.statementBranchWaitNaauReview' }
    case statementBranchApproved:
      return { color: 'success lighten-1', textColor: 'white--text', text: 'statuses.statementBranchApproved' }
    case statementBranchRejected:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.statementBranchRejected' }
    case statementBranchTechSentForReprocessing:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.statementBranchTechSentForReprocessing' }
    case statementBranchSentForReprocessing:
      return { color: 'error lighten-1', textColor: 'white--text', text: 'statuses.statementBranchSentForReprocessing' }

    default:
      return { color: 'primary lighten-1', textColor: 'white--text', text: 'statuses.default' }
  }
}

export const list = {
  statementCreateByLaboratory,
  statementWaitForClientSignature,
  statementWaitForCategoryChoices,
  statementWaitForDecision,
  statementReject,
  statementAllowedForInspection,
  statementDecisionWaitSignature,
  statementInProgressInspection,
  statementWaitSignatureAuditor,
  statementCertificateInProgress,
  statementCertificateIssued,
  statementCertificateNotIssued,
  statementWaitForLaboratory,
  statementWaitForCertificationAgency,
  statementWaitSignatureManager,
  statementDecisionWaitForDirectorSignature,
  statementDecisionWaitForSignatureExpert,
  statementDecisionWaitForSignatureChief,
  statementDecisionWaitForSignatureCertAuditor,
  statementDecisionWaitForSignatureCertDirector,
  statementWaitSignatureCertDirector,
  identificationActWaitDecisionAuditor,
  identificationActWaitSignatureForAuditor,
  identificationActWaitSignatureForManager,
  statementWaitReprocessing,

  statementManualWaitForClientSignature,
  statementManualWaitSignatureAuditor,
  statementManualWaitSignatureManager,
  statementManualWaitActIdentificationDecision,
  statementManualActIdentificationWaitSignatureAuditor,
  statementManualActIdentificationWaitSignatureManager,
  statementManualWaitForCertificationAgencyChoices,
  statementManualWaitChoiceLegalActs,
  statementManualRejected,
  statementManualCharacterizationVehicle,
  statementManualWaitSignatureCertAuditor,
  statementManualWaitSignatureCertDirector,
  statementManualCertificateIssued,

  statementDecisionWaitForSignatureAuditor,
  statementDecisionWaitForSignatureDirector,
  statementDecisionWaitForDecision,
  statementDecisionValid,

  inspectionWaitComplianceCompleted,
  inspectionUploadProofs,
  inspectionWaitForDecision,
  inspectionWaitStand,
  inspectionRejected,
  inspectionIssueCertificate,
  inspectionWitSignatureLabExpert,
  inspectionWitSignatureLabChief,
  inspectionWaitReprocessing,
  waitingAddInspectionProtocolNumber,

  decisionIssueCertificateWaitDecision,
  decisionIssueCertificateValid,
  decisionIssueCertificateWaitSignatureAuditor,
  decisionIssueCertificateWaitSignatureDirector,

  certificateWaitSignatureDirector,
  certificateWaitSignatureAuditor,
  certificateValid,

  decisionDecisionApproved,
  decisionDecisionReject,
  decisionDecisionWaitChoice,

  statementMTIWaitClientSign,
  statementMTIWaitPayment,
  statementMTIWaitDecision,
  statementMTIReject,
  statementMTIWaitInspection,
  statementMTIInProgressInspection,
  statementMTIWaitExpertSignature,
  statementMTIWaitSecondExpertSignature,
  statementMTIWaitChiefSignature,
  statementMTIWaitChiefSignatureAct,
  statementMTIWaitChiefSignatureProtocol,
  statementProcessMTIFinished,

  inspectionMTIWaitComplianceCompleted,
  inspectionMTIWaitStandInspection,
  inspectionMTIWaitSignatureExpert,
  inspectionMTIWaitSignatureSecondExpert,
  inspectionMTIWaitSignatureLabChief,
  inspectionMTIWaitSignatureLabChiefAct,
  inspectionMTIWaitSignatureLabChiefProtocol,
  inspectionProcessMTIFinished,

  inspectionMTIDecisionValid,
  inspectionMTIDecisionTinyDiscrepancy,
  inspectionMTIDecisionSignificantDiscrepancy,
  inspectionMTIDecisionDangerousDiscrepancy,
  inspectionMTIDecisionWaitAnswer,

  contractAwaitingDecision,
  contractValid,
  contractInvalid,
  contractNeedsExtension,

  activeCooperationAgreement,
  expiredCooperationAgreement,

  identificationActWaitDecision,
  identificationActWaitClientSignature,
  identificationActWaitSignatureAuditor,
  identificationActWaitSignatureManager,
  identificationActValid,
  identificationActRejected,

  employeeActive,
  employeeDeactivated,
  employeeSuspended,

  workLineApproved,
  workLineWaitRefinement,
  workLineWaitFilling,
  workLineModeration,

  laboratoryBranchWaitForModeration,
  laboratoryBranchReprocessing,
  laboratoryBranchApproved,

  inquiryNew,
  inquiryReviewed,
  inquiryInProgress,
  inquiryProcessed,
  inquiryDone,
  inquiryClosed,

  statementBranchSentForReprocessing,
  manualInspectionWaitFilling,
  manualInspectionReady,

  statusClientCanceled,
  statusWaitReview,
  statusClientSetDateKtz,
  statusClientInWork
}

export default {
  statement,
  statementClient,
  statementManual,
  statementDecision,
  inspection,
  inspectionMTI,
  decisionIssueCertificate,
  certificate,
  anyDecision,
  statementMTI,
  contractDecision,
  cooperationAgreement,
  identificationAct,
  employeeStatus,
  employeeOutOfSystemStatus,
  inspectionMTIDecision,
  workLineStatus,
  moderationMTZStatus,
  inquiry,
  statementBranch,
  manualInspection
}
